import axios from 'axios';
import env from './env';

axios.defaults.baseURL= env.baseUrl;
// axios.defaults
